<template>
    <button
        cy-data="submit"
        type="submit"
        :disabled="disabled"
        @click.prevent="submitForm(action)"
    >
        <slot />
        {{ buttonValue }}
    </button>
</template>

<script lang="ts">
import { defineComponent, ref, toRefs, PropType } from 'vue';
import { Action } from '@/constants/ajax';
import { useStore } from 'vuex';

export default defineComponent({
    name: 'SubmitButton',
    props: {
        action: {
            type: Number,
            required: true,
        },
        data: {
            type: Object,
            default: () => ({}),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        buttonValue: {
            type: String,
            default: '',
        },
        beforeSubmit: {
            type: Function as PropType<() => void>,
            default: (): void => {},
        },
    },
    emits: ['click'],
    setup(props, { emit }) {
        const { action, data, disabled, buttonValue, beforeSubmit } =
            toRefs(props);
        const store = useStore();
        const isSubmitting = ref(false);

        const submitForm = async (action: Action): Promise<void> => {
            if (isSubmitting.value) return;
            isSubmitting.value = true;
            const ajaxService = store.state.ajaxService;
            beforeSubmit.value();

            const pending = ajaxService.getPendingValidations();

            if (pending.length > 0) {
                try {
                    const results = await Promise.all(pending);

                    const hasError = results.some(() => {
                        return;
                    });

                    if (hasError) {
                        isSubmitting.value = false;
                        return;
                    }
                } catch (e) {
                    isSubmitting.value = false;
                    return;
                }
            }

            store
                .dispatch('ajax', {
                    action,
                    data: data.value,
                })
                .finally(() => {
                    isSubmitting.value = false;
                });

            emit('click');
        };

        return {
            action,
            data,
            disabled,
            buttonValue,
            submitForm,
        };
    },
});
</script>
